/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Trending_LabelInputs */

const en_header_trending_label = /** @type {(inputs: Header_Trending_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trending videos`)
};

/**
* | output |
* | --- |
* | "Trending videos" |
*
* @param {Header_Trending_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const header_trending_label = /** @type {((inputs?: Header_Trending_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Trending_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_trending_label(inputs)
});
export { header_trending_label as "header.trending.label" }